var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.6666 6.99986C13.6666 10.6825 10.6819 13.6665 6.99993 13.6665C3.31793 13.6665 0.333267 10.6825 0.333267 6.99986C0.333267 3.31852 3.31793 0.333191 6.99993 0.333191C10.6819 0.333191 13.6666 3.31852 13.6666 6.99986Z",
    fill: "#B1B1B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99666 8.95234C7.32533 8.95234 7.58666 9.21434 7.58666 9.53567C7.58666 9.85701 7.32533 10.119 7.00333 10.119C6.68 10.119 6.41666 9.85701 6.41666 9.53567C6.41666 9.21434 6.67733 8.95234 6.99666 8.95234ZM6.99666 3.89047C7.318 3.89047 7.58 4.15247 7.58 4.47381V7.42047C7.58 7.74181 7.318 8.00381 6.99666 8.00381C6.67533 8.00381 6.41333 7.74181 6.41333 7.42047V4.47381C6.41333 4.15247 6.67533 3.89047 6.99666 3.89047Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/Info-Circle.c760ee29862abcd1eaffdbe7cdf9958b.svg";
export { ForwardRef as ReactComponent };